// extracted by mini-css-extract-plugin
export default {"background":"Home_background__Tmczw","studio_name":"Home_studio_name__WF+--","xxx":"Home_xxx__n3nuk"};